import { Text } from 'src/components/ui'

export function NoRecentlyDiscoveredNodesOverlay({
  duration,
}: {
  duration: string
}): JSX.Element {
  return (
    <div className="size-full">
      <div className="flex h-[48px] w-full items-center border-0 border-b border-solid border-border px-s">
        <Text bold>No recently discovered nodes the last {duration}</Text>
      </div>
    </div>
  )
}
